import React, { useState, useEffect } from "react";
import "./SidePanel.css";
import API_BASE_URL from "./RestAPI.js";
import { showSuccessToast, showErrorToast } from "../constants/ToastService.js";

const SidePanel = ({ closePanel, editData, panelType, setRefreshData, buttonType }) => {
    const initialFormData = {
        project: { project_name: "", project_description: "", project_manager_id: null, is_active: true },
        designation: { designation_name: '', designation_prefix: '', is_active: true },
        employee: { name: "", email: "", mobile_number: null, is_active: true, login_role_id: null, login_name: "", password: "" },
        team: { team_name: "", is_active: true },
        status: { ticket_status: '', description: '', environment: "", is_active: true },
        clientstatus: { client_requirement_status: '', description: '', is_active: true },
        client: { client_name: '', client_email: '', client_mobile_number: '', is_active: true },
        ticketType: { type_name: '', is_active: true },
        priorityType: { priority: '', is_active: true },
        module: { module_name: '', short_name: '', is_active: true },
        subModule: { sub_module_name: '', short_name: '', module_id: '', is_active: true },
        environment: { environment: '', short_name: '', is_active: true },
        loginUser: { user_name: '', password: '', email: '', employee_id: null, is_active: true },
        loginRole: { role_name: '', permissions: { 'Home': true, 'Sprints': true, 'Delete Ticket' : false, 'Kanban Chart': true, 'Dashboards': true, 'Reports': true, 'Masters': true, 'Request Live Move': false, 'Approve Live Move': false, 'Task Assignment': false }, is_active: true },
        impactarea: { name: '', project_id: null, is_active: true },
        gitlabrepo: { repo_name: '', gitlab_project_id: '', gitlab_project_path: '', gitlab_url: '', api_token: '', repo_type: 'frontend', project_id: null, is_active: true }
    };

    const [formData, setFormData] = useState(initialFormData[panelType]);
    const [employees, setEmployees] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [loginRoles, setLoginRoles] = useState([]);
    const [Projects, setProjects] = useState([]);
    const [modules, setModules] = useState([]);
    const defaultLoginRoles = ['ADMIN', 'MANAGER', 'LEAD', 'MEMBER'];
    const [impactAreaNames, setImpactAreaNames] = useState([]);
    const [impactAreaInput, setImpactAreaInput] = useState('');
    const screenNames = ['Dashboards', 'Sprints', 'Delete Ticket', 'Kanban Chart', 'Client Requirements', 'Reports', 'Masters', 'Error Tracking', 'Customer Support', 'Request Live Move', 'Approve Live Move', 'Task Assignment', 'Quality', 'Log Production Bug', 'Manage Releases', 'Run Regression', 'Manage Test Cases', 'Approve RCA']

    useEffect(() => {
        if (editData) {
            setFormData(editData);
        }
    }, [editData]);

    useEffect(() => {
        if (panelType === "project" || panelType === 'team' || panelType === 'loginUser') {
            fetch(`${API_BASE_URL}core/employee/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.status === "success") {
                        setEmployees(data.data);
                    } else {
                        showErrorToast("Failed to load employees");
                    }
                })
                .catch((err) => console.error("Error fetching employees:", err));
        }
    }, [panelType]);

    useEffect(() => {
        if (panelType === "employee") {
            fetch(`${API_BASE_URL}core/designation/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.status === "success") {
                        setDesignations(data.data);
                    } else {
                        showErrorToast("Failed to load Designation");
                    }
                })
                .catch((err) => console.error("Error fetching Designation:", err));

            fetch(`${API_BASE_URL}core/loginRole/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.status === "success") {
                        setLoginRoles(data.data);
                    } else {
                        showErrorToast("Failed to load Login Roles");
                    }
                })
                .catch((err) => console.error("Error fetching Login Roles:", err));
        }
    }, [panelType]);

    useEffect(() => {
        if (panelType === "client" || panelType === "impactarea" || panelType === "gitlabrepo") {
            fetch(`${API_BASE_URL}core/project/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.status === "success") {
                        setProjects(data.data);
                    } else {
                        showErrorToast("Failed to load Designation");
                    }
                })
                .catch((err) => console.error("Error fetching Designation:", err));
        }
    }, [panelType]);

    useEffect(() => {
        if (panelType !== "subModule") return;
        fetch(`${API_BASE_URL}core/module/`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.status === "success") {
                    setModules((data.data || []).filter((m) => !m.is_delete));
                } else {
                    showErrorToast("Failed to load modules");
                }
            })
            .catch((err) => console.error("Error fetching modules:", err));
    }, [panelType]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "mobile_number") {
            if (/^\d*$/.test(value)) {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async () => {
        // Multi-add for new impact areas
        if (panelType === 'impactarea' && !editData) {
            const names = [...impactAreaNames];
            if (impactAreaInput.trim()) names.push(impactAreaInput.trim());
            if (names.length === 0) { showErrorToast("Add at least one impact area name"); return; }
            if (!formData.project_id) { showErrorToast("Select a project"); return; }

            const url = `${API_BASE_URL}client_requirements/impact-areas/`;
            const hdrs = { "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('authToken')}` };
            let successCount = 0;
            let lastError = '';

            for (const name of names) {
                try {
                    const res = await fetch(url, { method: "POST", headers: hdrs, body: JSON.stringify({ ...formData, name }) });
                    const data = await res.json();
                    if (data.status === "success") successCount++;
                    else lastError = data.message;
                } catch { lastError = "Network error"; }
            }

            if (successCount > 0) {
                showSuccessToast(`${successCount} impact area${successCount > 1 ? 's' : ''} created successfully`);
                setRefreshData((prev) => !prev);
                closePanel();
            }
            if (lastError && successCount < names.length) {
                showErrorToast(`${names.length - successCount} failed: ${lastError}`);
            }
            return;
        }

        let url;
        if (panelType === 'impactarea') {
            url = `${API_BASE_URL}client_requirements/impact-areas/`;
        } else if (panelType === 'gitlabrepo') {
            url = `${API_BASE_URL}ticketing/gitlab/repos/`;
        } else if (panelType === 'client' || panelType === 'clientstatus') {
            url = `${API_BASE_URL}client_requirements/${panelType}/`;
        } else if (panelType === 'subModule') {
            url = `${API_BASE_URL}core/sub-module/`;
        } else {
            url = `${API_BASE_URL}core/${panelType}/`;
        }
        let method = editData ? "PUT" : "POST";

        await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(formData),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.status === "success") {
                    showSuccessToast(data.message);
                    setRefreshData((prev) => !prev);
                    closePanel();

                } else if (data.status === "fail") {
                    showErrorToast(data.message);
                }
            })
            .catch(() => {
                console.log("Failed to save data");
            });

    };

    return (
        <div className="side-panel">
            <h3>{editData ? "Edit" : "Add"} {buttonType}</h3>
            <div className="side-panel-body">
            {panelType === "project" && (
                <>
                    <input type="text" name="project_name" value={formData.project_name} onChange={handleChange} placeholder="Project Name *" />
                    <input type="text" name="project_description" value={formData.project_description} onChange={handleChange} placeholder="Project Description" />
                    <select className='select' name="project_manager_id" value={formData.project_manager_id || ""} onChange={handleChange}>{formData.project_manager_name}
                        <option className='option_dropdown' value="" disabled hidden>Select Project Manager</option>
                        {(employees || []).map((employee) => (
                            <option className='option_dropdown' key={employee.id} value={employee.id}>
                                {employee.name}
                            </option>
                        ))}
                    </select>
                    <div className="checkbox-container">
                        <input
                            style={{ color: 'red' }}
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "designation" && (
                <>
                    <input type="text" name="designation_name" value={formData.designation_name} onChange={handleChange} placeholder="Designation Name *" />
                    <input type="text" name="designation_prefix" value={formData.designation_prefix} onChange={handleChange} placeholder="Desgination Prefix *" />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "employee" && (
                <>
                    <input required type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Employee Name *" />
                    <input required type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email *" pattern="^[a-zA-Z0-9._%+-]+@example\.com$" />
                    <input type="text" name="mobile_number" maxLength={10} value={formData.mobile_number} onChange={handleChange} placeholder="Mobile Number *" />
                    <input required type="text" name="login_name" value={formData.login_name} onChange={handleChange} placeholder="Username" />
                    <input required type="text" name="password" value={formData.password} onChange={handleChange} placeholder="Password" />
                    <select className='select' name="login_role_id" value={formData.login_role_id || ""} onChange={handleChange}>{formData.login_role_name}
                        <option className='option_dropdown' value="" disabled hidden>Select Login Role *</option>
                        {(loginRoles || []).map((loginRole) => (
                            <option className='option_dropdown' key={loginRole.id} value={loginRole.id}>
                                {loginRole.role_name}
                            </option>
                        ))}
                    </select>
                    <br></br>
                    <br></br>
                    <select className='select' name="role_id" value={formData.role_id || ""} onChange={handleChange}>{formData.role_name}
                        <option className='option_dropdown' value="" disabled hidden>Select Desgination *</option>
                        {(designations || []).map((designation) => (
                            <option className='option_dropdown' key={designation.id} value={designation.id}>
                                {designation.designation_name}
                            </option>
                        ))}
                    </select>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "team" && (
                <>
                    <input type="text" name="team_name" value={formData.team_name} onChange={handleChange} placeholder="Team Name" />
                    <select className='select' name="team_lead_id" value={formData.team_lead_id || ""} onChange={handleChange}>{formData.team_lead_name}
                        <option className='option_dropdown' value="" disabled hidden>Select Team Manager</option>
                        {(employees || []).map((employee) => (
                            <option className='option_dropdown' key={employee.id} value={employee.id}>
                                {employee.name}
                            </option>
                        ))}
                    </select>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "status" && (
                <>
                    <input type="text" name="ticket_status" value={formData.ticket_status} onChange={handleChange} placeholder="Ticket Status *" />
                    <input type="text" name="description" value={formData.description} onChange={handleChange} placeholder="Status Description" />
                    <select
                        className='select'
                        value={formData.environment}
                        onChange={(e) =>
                            setFormData((prevState) => ({
                                ...prevState,
                                environment: e.target.value,
                            }))
                        }>
                        <option className='option_dropdown' value="">Environment</option>
                        <option className='option_dropdown' value="DEV">DEV</option>
                        <option className='option_dropdown' value="QA">QA</option>
                        <option className='option_dropdown' value="UAT">UAT</option>
                        <option className='option_dropdown' value="Live">Live</option>
                    </select>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "client" && (
                <>
                    <form>
                        <input type="text" name="client_name" value={formData.client_name} onChange={handleChange} placeholder="Client Name" />
                        <input type="email" name="client_email" value={formData.client_email} onChange={handleChange} placeholder="Client Email ID" required />
                        <input type="tel" name="client_mobile_number" value={formData.client_mobile_number} onChange={handleChange} placeholder="Client Mobile No" />
                        <select className='select' name="project_id" value={formData.project_id || ""} onChange={handleChange}>{formData.project_name}
                            <option className='option_dropdown' value="" disabled hidden>Select Project</option>
                            {(Projects || []).map((project) => (
                                <option className='option_dropdown' key={project.id} value={project.id}>
                                    {project.project_name}
                                </option>
                            ))}
                        </select>
                    </form>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "clientstatus" && (
                <>
                    <input type="text" name="client_requirement_status" value={formData.client_requirement_status} onChange={handleChange} placeholder="Requirement Status *" />
                    <input type="text" name="description" value={formData.description} onChange={handleChange} placeholder="Status Description" />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "impactarea" && (
                <>
                    {editData ? (
                        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Impact Area Name *" />
                    ) : (
                        <div>
                            <div className="impact-chip-input-wrapper">
                                <div className="impact-chips">
                                    {impactAreaNames.map((name, i) => (
                                        <span key={i} className="impact-chip">
                                            {name}
                                            <button type="button" className="impact-chip-remove" onClick={() => setImpactAreaNames(prev => prev.filter((_, idx) => idx !== i))}>×</button>
                                        </span>
                                    ))}
                                </div>
                                <input
                                    type="text"
                                    value={impactAreaInput}
                                    onChange={(e) => setImpactAreaInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if ((e.key === 'Enter' || e.key === ',') && impactAreaInput.trim()) {
                                            e.preventDefault();
                                            const val = impactAreaInput.trim().replace(/,+$/, '');
                                            if (val && !impactAreaNames.includes(val)) {
                                                setImpactAreaNames(prev => [...prev, val]);
                                            }
                                            setImpactAreaInput('');
                                        } else if (e.key === 'Backspace' && !impactAreaInput && impactAreaNames.length > 0) {
                                            setImpactAreaNames(prev => prev.slice(0, -1));
                                        }
                                    }}
                                    placeholder={impactAreaNames.length === 0 ? "Type impact area name and press Enter" : "Add more..."}
                                />
                            </div>
                            <span className="impact-chip-hint">{impactAreaNames.length} area{impactAreaNames.length !== 1 ? 's' : ''} added</span>
                        </div>
                    )}
                    <select className='select' name="project_id" value={formData.project_id || ""} onChange={handleChange}>
                        <option className='option_dropdown' value="" disabled hidden>Select Project *</option>
                        {(Projects || []).map((project) => (
                            <option className='option_dropdown' key={project.id} value={project.id}>
                                {project.project_name}
                            </option>
                        ))}
                    </select>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "gitlabrepo" && (
                <>
                    <input type="text" name="repo_name" value={formData.repo_name} onChange={handleChange} placeholder="Repository Name *" />
                    <select className='select' name="project_id" value={formData.project_id || ""} onChange={handleChange}>
                        <option className='option_dropdown' value="" disabled hidden>Select Project *</option>
                        {(Projects || []).map((project) => (
                            <option className='option_dropdown' key={project.id} value={project.id}>{project.project_name}</option>
                        ))}
                    </select>
                    <input type="number" name="gitlab_project_id" value={formData.gitlab_project_id} onChange={handleChange} placeholder="GitLab Project ID *" />
                    <input type="text" name="gitlab_project_path" value={formData.gitlab_project_path} onChange={handleChange} placeholder="GitLab Path (e.g. fixdesk1/MINIMI-FE)" />
                    <input type="text" name="gitlab_url" value={formData.gitlab_url} onChange={handleChange} placeholder="GitLab URL (e.g. https://gitlab.com/fixdesk1/MINIMI-FE)" />
                    <input type="password" name="api_token" value={formData.api_token} onChange={handleChange} placeholder={editData ? "New Token (leave blank to keep current)" : "GitLab Access Token *"} autoComplete="new-password" />
                    <select className='select' name="repo_type" value={formData.repo_type || "frontend"} onChange={handleChange}>
                        <option value="frontend">Frontend</option>
                        <option value="backend">Backend</option>
                        <option value="microservice">Microservice</option>
                        <option value="mobile">Mobile</option>
                        <option value="other">Other</option>
                    </select>
                    <div className="checkbox-container">
                        <input type="checkbox" name="is_active" checked={formData.is_active} onChange={(e) => setFormData((prev) => ({ ...prev, is_active: e.target.checked }))} />
                        <label>Is Active</label>
                    </div>
                </>
            )}

            {panelType === "loginRole" && (
                <>
                    <form>
                        <input type="text" name="role_name" value={formData.role_name} onChange={handleChange} placeholder="Role Name *" />
                    </form>
                    <br></br>
                    <h3>Select Permissions for this Role</h3>
                    {(screenNames || []).map((screen) => (
                        <div key={screen} className="checkbox-container">
                            <input
                                type="checkbox"
                                id={`checkbox-${screen}`}
                                name={screen}
                                checked={formData.permissions?.[screen] || false}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        permissions: {
                                            ...prev.permissions,
                                            [screen]: e.target.checked,
                                        },
                                    }))
                                }
                            />
                            <label htmlFor={`checkbox-${screen}`}>{screen}</label>
                        </div>
                    ))}
                    <br></br>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "loginUser" && (
                <>
                    <input type="text" name="user_name" value={formData.user_name} onChange={handleChange} placeholder="User Name" />
                    <input type="text" name="password" value={formData.password} onChange={handleChange} placeholder="Password" />
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email ID" required />
                    <select className='select' name="employee_id" value={formData.employee_id || ""} onChange={handleChange}>{formData.employee_name}
                        <option className='option_dropdown' value="" disabled hidden>Select Employee</option>
                        {(employees || []).map((employee) => (
                            <option className='option_dropdown' key={employee.id} value={employee.id}>
                                {employee.name}
                            </option>
                        ))}
                    </select>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "ticketType" && (
                <>
                    <input type="text" name="type_name" value={formData.type_name} onChange={handleChange} placeholder="Ticket Type *" />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "priorityType" && (
                <>
                    <input type="text" name="priority" value={formData.priority} onChange={handleChange} placeholder="Priority Type *" />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "module" && (
                <>
                    <input type="text" name="module_name" value={formData.module_name} onChange={handleChange} placeholder="Module Name" />
                    <input type="text" name="short_name" value={formData.short_name} onChange={handleChange} placeholder="Short Name" />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "subModule" && (
                <>
                    <select name="module_id" value={formData.module_id || ''} onChange={handleChange}>
                        <option value="">Module *</option>
                        {modules.map((m) => (
                            <option key={m.id} value={m.id}>{m.module_name}</option>
                        ))}
                    </select>
                    <input type="text" name="sub_module_name" value={formData.sub_module_name || ''} onChange={handleChange} placeholder="Sub-Module Name * (e.g. Sales Return)" />
                    <input type="text" name="short_name" value={formData.short_name || ''} onChange={handleChange} placeholder="Short Name" maxLength={7} />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            {panelType === "environment" && (
                <>
                    <input type="text" name="environment_name" value={formData.environment_name} onChange={handleChange} placeholder="Environment Name *" />
                    <input type="text" name="short_name" value={formData.short_name} onChange={handleChange} placeholder="Short Name" />
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    is_active: e.target.checked,
                                }))
                            }
                        />
                        <label htmlFor="isActive">Is Active</label>
                    </div>
                </>
            )}

            </div>
            <div className="side-panel-actions">
                <button className='save-btn' onClick={() => {
                    if (panelType === "subModule" && (!formData.module_id || !(formData.sub_module_name || '').trim())) {
                        showErrorToast("Choose a module and enter the sub-module name");
                    } else if (panelType === "employee") {
                        if (!formData.name) {
                            showErrorToast("Enter the Employee Name")
                        } else if (!formData.email) {
                            showErrorToast("Enter the Employee Mail ID")
                        } else {
                            handleSubmit()
                        }
                    } else {
                        handleSubmit()
                    }
                }}>Save</button>
                <button className='cancel-btn' onClick={closePanel}>Cancel</button>
            </div>
        </div>
    );
};

export default SidePanel;
